export class RegexHelper {

    static escapeSquareBrackets(value: string): string {
		// checks for [] and for \[ \] to escape them. only replaces if there is an nothing or an even number of \ before the [ or ]
        return  value.replace(/(?:(?<!\\)(?:\\\\)*)[[\]]/g, '\\$&');
    }

}